<template>
  <div class="m-3" v-if="homeitem.items.length !== 0">
    <!-- <section class="home-header" ref="homeHeader">
      <img
        class="home-header__img"
        v-lazy="`https://assets.urlaubsgutschein.kaufen/i/crop?width=1200&height=400&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg`"
        :data-srcset="
          `https://assets.urlaubsgutschein.kaufen/i/crop?width=360&height=200&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 360w,
          https://assets.urlaubsgutschein.kaufen/i/crop?width=520&height=200&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 520w,
          https://assets.urlaubsgutschein.kaufen/i/crop?width=768&height=200&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 768w,
          https://assets.urlaubsgutschein.kaufen/i/crop?width=1024&height=350&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 1024w,
          https://assets.urlaubsgutschein.kaufen/i/crop?width=1216&height=350&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 1216w,
          https://assets.urlaubsgutschein.kaufen/i/crop?width=1408&height=400&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 1400w,
          https://assets.urlaubsgutschein.kaufen/i/crop?width=2000&height=400&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 2000w,
          https://assets.urlaubsgutschein.kaufen/i/crop?width=2600&height=400&quality=50&interlace=true&type=auto&file=/whitelabel/${this.partialUrl}/${homeitem.value.toLowerCase()}.jpg 2600w,`
        "
        alt=""
      />
      <div class="has-text-centered home-header__titlearea">
        <h2 class="title home-header__title is-size-5-mobile is-size-4-tablet is-size-3-desktop	">
          {{ homeitem.title }}
        </h2>
        <h3 class="subtitle home-header__subtitle is-size-6-mobile">
          {{ homeitem.description }}
        </h3>
      </div>
       <div class="has-background-primary home-header__overlay"></div> 
    </section> -->

    <h2 class="title home-header__title is-size-4-mobile is-size-3-desktop	">
      {{ homeitem.title }}
    </h2>
    <h3 class="subtitle home-header__subtitle is-size-6-mobile is-size-6-tablet is-size-5-desktop">
      {{ homeitem.description }}
    </h3>

    <!-- <div v-if="homeitem.items.length === 0" class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold mb-6">
      <b-icon icon="sad-cry" size="is-large"></b-icon>
      <br />{{ $t('errors.no-offers') }}
    </div> -->

    <div class="columns is-multiline mb-6">
      <div class="column  is-flex" v-for="product in homeitem.items" :key="product.id" :class="{'is-full': isTravelDeal(product), 'is-half-tablet is-one-third-desktop': !isTravelDeal(product)}">
        <OfferElement v-if="!isTravelDeal(product)" :product="product" />
        <Deal v-if="isTravelDeal(product)" :product="product" />
      </div>
    </div>
  </div>
</template>

<script>
import OfferElement from '@/components/OfferElement'
import Deal from '@/components/Deal'
import promotion from '@/common/promotion'
export default {
  name: 'HomeSection',
  props: {
    homeitem: Object,
  },
  components: {
    OfferElement,
    Deal,
  },
  data() {
    return {}
  },
  computed: {
    // a computed getter
    partialUrl: function() {
      // `this` points to the vm instance
      switch (this.homeitem.name) {
        case 'country':
          return '_assets/images/countries'
        case 'category':
          return '_assets/images/categories'
        case 'promotion':
          return '_assets/images/promotions'
      }

      return this.homeitem.name
    },
  },
  methods: {
    isTravelDeal(f) {
      return promotion.hasActivePromotion('TravelDeal', f)
    },
  },
  mounted: function() {},
}
</script>

<style lang="scss">
.home-header {
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  height: 200px;

  @media screen and (min-width: 1024px) {
    height: 350px;
  }
  @media screen and (min-width: 1408px) {
    height: 400px;

    margin-left: 0;
    margin-right: 0;
    left: 0;
    right: 0;
    width: auto;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
}

// .home-section {
//   @media screen and (min-width: 1408px) {
//     background-color: #fff;
//   }
// }

// .home-header__overlay {
//   filter: opacity(0.3);
//   position: absolute;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   mix-blend-mode: color-burn;
// }

// .home-header__img {
//   object-fit: cover;
//   object-position: center;
//   width: 100%;
//   height: 100%;
// }

// .home-header__titlearea {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex-direction: column;
//   position: absolute;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   z-index: 1;
//   margin-left: 1.5rem;
//   margin-right: 1.5rem;
// }

// .home-header__title,
// .home-header__subtitle {
//   background-color: #fff;
//   padding: 0.5rem 1rem;
//   border-radius: 2px;
// }

// .home-header__title{
//   font-size:
// }

// .home-header__subtitle {
//   padding: 0.5rem;
//   margin-top: -0.5rem !important;
// }
</style>
